
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class FreshworksReaderService {

   public static getCustomerDetailsChpp(
           axiosInstance: AxiosInstance, input: ServerData.FreshworksWebReader.GetCustomerDetailsChpp$Input,
           f: (output: ServerData.FreshworksWebReader.GetCustomerDetailsChpp$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/freshworks/get-customer-details-chpp',
            {params : input.toJson()}
        ).then((response) => ServerData.FreshworksWebReader.GetCustomerDetailsChpp$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

